export * from './GiftCardsHeading';
